import { createContext, useContext, type ReactNode } from "react";
import type { ObjectUiAdapter } from "./object-ui-adapter";

const ObjectUiAdapterContext = createContext<ObjectUiAdapter | null>(null);

/** Makes the object UI's adapter available to One's pages and the command shell. */
export function ObjectUiAdapterProvider({
  adapter,
  children,
}: {
  adapter: ObjectUiAdapter;
  children: ReactNode;
}) {
  return (
    <ObjectUiAdapterContext.Provider value={adapter}>
      {children}
    </ObjectUiAdapterContext.Provider>
  );
}

export function useObjectUiAdapter(): ObjectUiAdapter {
  const adapter = useContext(ObjectUiAdapterContext);
  if (!adapter) {
    throw new Error(
      "useObjectUiAdapter must be used within an ObjectUiAdapterProvider",
    );
  }
  return adapter;
}
